import  gql  from 'graphql-tag'

export const EDIT_SETTINGS = gql`mutation systemSettings($input: SystemSettingsMutationInput!){
    systemSettings(input: $input){
        systemSettings{
            versionId
            idleTime
            ftpHost
            ftpPort
            ftpUsername
            ftpPath
            daysResume
            alert
            salary
            ipc
            health
            pension
            arl
            compensation
            severancePayInterest
            ageForAssurance
            ageForAssurancePercentBelow
            ageForAssurancePercentAbove
            creditLineMinAmountMicro
            creditLineMaxAmountMicro
            creditLineMaxAmountPercentMicro
            creditLineDestinationMicro
            creditLineQuotaQtyMicro
            creditLineStatementDateRange1Micro
            creditLineStatementDateRange2Micro
            creditLineMinAmountPyme
            creditLineMaxAmountPyme
            creditLineMaxAmountPercentPyme
            creditLineDestinationPyme
            creditLineQuotaQtyPyme
            creditLineStatementDateRange1Pyme
            creditLineStatementDateRange2Pyme
            creditLineMinAmountAgro
            creditLineMaxAmountAgro
            creditLineMaxAmountPercentAgro
            creditLineDestinationAgro
            creditLineQuotaQtyAgro
            creditLineStatementDateRange1Agro
            creditLineStatementDateRange2Agro
        }
        errors{
            field
            messages
        }
    }
}`;